<template>
    <div>
        <Radio
            @radioClick="()=>handleClick(option)"
            :active="
                (props.selectedOption && props.selectedOption.value === option.value) ? true : false
            "
            v-for="(option, option_i) in props.options"
            :key="option_i"
            :option="option"
            :disabled="props.disabled"
        >
            <slot :option="option" />
        </Radio>
    </div>
</template>

<script lang="ts" setup>
import { computed, withDefaults, defineProps, defineEmits } from 'vue'

import Radio from '@/components/LoginRegister/common/inputs/Radio/v1/Radio.vue'

type Value = string | number | boolean
type Option = {
    label?: string
    value: boolean
    imgSrc?: string
}
type OptionList = Option[]

interface Props {
    options: OptionList
    selectedOption?: Option
    disabled?: boolean
}
interface Emits {
    (e: "radioClick", option: Option): void
}

// props
const props = withDefaults(defineProps<Props>(), {
})

// emit
const emit = defineEmits<Emits>()


// handlers
const handleClick = (option: Option) => {
    emit('radioClick', option)
}
</script>

<style  scoped>
</style>